<script>
  import { bottomNavList, editBottomNav } from '@/api/bottomNav'
  import imageUpload from '@/components/ImageUpload/index.vue'
  import BottomNavDrawer from './components/BottomNavDrawer.vue'

  export default {
    name: 'BottomNav',
    components: {
      imageUpload,
      BottomNavDrawer
    },
    data() {
      return {
        // 表格数据
        tableData: [],
        // 加载状态
        loading: false,
        // 弹窗显示状态
        dialogVisible: false,
        // 抽屉显示状态
        drawerVisible: false,
        // 当前选中的导航ID
        currentNavId: '',
        // 当前编辑的数据
        currentForm: {
          id: '',
          name: '',
          imgUrl: '',
          optImgUrl: '',
          jumpPage: '',
          updatePerson: '',
          updateTime: ''
        },
        // 表单规则
        rules: {
          name: [
            { required: true, message: '请输入导航名称', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback()
                  return
                }

                // 使用更精确的表情符号检测方法
                // 这个正则表达式专门匹配表情符号，不会误判数字
                const emojiRegex =
                  /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u

                if (emojiRegex.test(value)) {
                  callback(new Error('导航名称不能包含表情符号'))
                  return
                }

                callback()
              },
              trigger: 'blur'
            }
          ],
          imgUrl: [{ required: true, message: '请上传导航图片', trigger: 'change' }],
          optImgUrl: [{ required: true, message: '请上传选中图片', trigger: 'change' }],
          jumpPage: [{ required: true, message: '请输入跳转页面名称', trigger: 'blur' }]
        }
      }
    },
    created() {
      this.getTableData()
    },
    computed: {
      sizeObj() {
        const map = new Map([
          [1, { width: 48, height: 48 }],
          [2, { width: 84, height: 84 }],
          [3, { width: 48, height: 48 }]
        ])
        const { id } = this.currentForm
        return map.has(id) ? map.get(id) : { width: 48, height: 48 }
      }
    },
    methods: {
      // 获取表格数据
      async getTableData() {
        this.loading = true
        try {
          const res = await bottomNavList()
          if (res.data) {
            this.tableData = res.data
          }
        } catch (error) {
          console.error('获取底部导航列表失败', error)
          this.$message.error('获取底部导航列表失败')
        } finally {
          this.loading = false
        }
      },

      // 打开编辑弹窗
      async handleEdit(row) {
        try {
          // 先获取详情数据
          // const res = await bottomNavDetail({ id: row.id })
          // if (res.data) {
          //   this.currentForm = res.data
          // } else {
          //
          // }
          this.currentForm = JSON.parse(JSON.stringify(row))
          this.dialogVisible = true
        } catch (error) {
          console.error('获取导航详情失败', error)
          this.$message.error('获取导航详情失败')
        }
      },

      // 打开详情抽屉
      handleViewDetail(row) {
        this.currentNavId = row.id
        this.drawerVisible = true
      },

      // 获取上传图片
      getImg(url, prop) {
        this.currentForm[prop] = url
      },

      // 保存编辑
      handleSave() {
        this.$refs.editForm.validate(async (valid) => {
          if (valid) {
            this.$confirm('保存后乘客端内立即生效，是否确认保存?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(async () => {
              try {
                const res = await editBottomNav(this.currentForm)
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.dialogVisible = false
                  this.getTableData()
                } else {
                  this.$message.error(res.msg || '保存失败')
                }
              } catch (error) {
                console.error('保存失败', error)
                this.$message.error('保存失败')
              }
            })
          }
        })
      },

      // 取消编辑
      handleCancel() {
        this.dialogVisible = false
        this.currentForm = {
          id: '',
          name: '',
          imgUrl: '',
          optImgUrl: '',
          jumpPage: '',
          updatePerson: '',
          updateTime: ''
        }
      }
    }
  }
</script>

<template>
  <div class="bottom-nav-container">
    <!-- 表格 -->
    <el-table :data="tableData" v-loading="loading" border style="width: 100%">
      <el-table-column label="页面入口" min-width="120">
        <template slot-scope="scope">
          <span class="link-type" @click="handleViewDetail(scope.row)">
            {{ scope.row.jumpPage }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="名称" min-width="180" />
      <el-table-column label="未选中的图片" min-width="120">
        <template slot-scope="{ row }">
          <el-image
            style="width: 50px; height: 50px"
            :src="row.imgUrl"
            fit="contain"
            v-if="row.imgUrl"
          />
          <div v-else></div>
        </template>
      </el-table-column>
      <el-table-column label="选中的图片" min-width="120">
        <template slot-scope="{ row }">
          <el-image
            style="width: 50px; height: 50px"
            :src="row.optImgUrl"
            fit="contain"
            v-if="row.optImgUrl"
          />
          <div v-else></div>
        </template>
      </el-table-column>
      <!--      <el-table-column prop="jumpPage" label="跳转页面名称" min-width="180" />-->
      <el-table-column prop="updatePerson" label="最新编辑人" min-width="120" />
      <el-table-column prop="updateTime" label="最新编辑时间" min-width="180" />
      <el-table-column label="操作" min-width="120">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleEdit(scope.row)"
            v-has-permi="['user_advertising_edit']"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑弹窗 -->
    <el-dialog title="编辑导航" :visible.sync="dialogVisible" width="600px">
      <el-form
        ref="editForm"
        :model="currentForm"
        :rules="rules"
        label-width="120px"
        size="small"
        v-if="dialogVisible"
      >
        <!-- 入口名称 -->
        <el-form-item label="入口名称：" prop="name">
          <el-input
            v-model="currentForm.name"
            placeholder="不超过6个字符"
            maxlength="6"
            show-word-limit
            style="width: 300px"
          />
          <!--          <div class="input-limit">0/6</div>-->
        </el-form-item>

        <!-- 未选中状态 -->
        <el-form-item label="未选中状态" prop="imgUrl">
          <imageUpload
            :imageList="currentForm.imgUrl ? [{ url: currentForm.imgUrl }] : []"
            :limit="1"
            :fileSize="1"
            :isShowTip="true"
            :WHtip="true"
            :width="sizeObj.width"
            :height="sizeObj.height"
            :fileType="['png', 'jpg']"
            accept=".jpg,.png"
            :multiple="false"
            @input="(val) => getImg(val, 'imgUrl')"
            code="advertising"
          />
          <!--          <div class="upload-tip">jpg/png格式<br />大小150*150，不超过1M</div>-->
        </el-form-item>

        <!-- 已选中状态 -->
        <el-form-item label="已选中状态" prop="optImgUrl">
          <imageUpload
            :imageList="currentForm.optImgUrl ? [{ url: currentForm.optImgUrl }] : []"
            :limit="1"
            :fileSize="1"
            :isShowTip="true"
            :WHtip="true"
            :width="sizeObj.width"
            :height="sizeObj.height"
            :fileType="['png', 'jpg']"
            accept=".jpg,.png"
            :multiple="false"
            @input="(val) => getImg(val, 'optImgUrl')"
            code="advertising"
          />
        </el-form-item>

        <!-- 跳转页面名称 -->
        <!--        <el-form-item label="跳转页面名称：" prop="jumpPage">-->
        <!--          <el-input v-model="currentForm.jumpPage" placeholder="请输入" style="width: 300px" />-->
        <!--        </el-form-item>-->
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>

    <!-- 详情抽屉 -->
    <BottomNavDrawer :visible.sync="drawerVisible" :id="currentNavId" />
  </div>
</template>

<style scoped lang="scss">
  .bottom-nav-container {
    padding: 20px;
  }

  .upload-tip {
    color: #f56c6c;
    font-size: 12px;
    margin-top: 5px;
  }

  .link-type {
    color: #409eff;
    text-decoration: none;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  .upload-label {
    margin-bottom: 8px;
  }

  .input-limit {
    position: absolute;
    right: 10px;
    top: 0;
    color: #999;
    font-size: 12px;
  }
</style>
